import { useEffect, useRef, useState } from "react";
import { closeIcon } from "../../../assets/icons";
import { useDispatch, useSelector } from "react-redux";
import { fetchIframeData, resetfetchIframeData } from "../store/actions";
import { encodeFormData } from "../../../utils";
import { useLegacySupport } from "../../../components";

// rewrite the following code to check which event listerner is available and then use it

// @ts-ignore: Unreachable code error
const eventMethod: string = window.addEventListener ? "addEventListener" : "attachEvent";

// @ts-ignore: Unreachable code error
const eventer: any = window[eventMethod];
const messageEvent = "attachEvent" === eventMethod ? "onmessage" : "message";

// Functional component for Information Governance
const IFrameWrapperDashboard = (props: any) => {
    const dispatch = useDispatch();
    const token = useLegacySupport()

    const iframeRef = useRef<HTMLIFrameElement>(null);

    const iframeConfigData = useSelector((state: any) => state.iframeConfigData);

    const [iframeData, setIframeData] = useState<any>(null);


    useEffect(() => {
        try {
            setIframeData(null);

            let params: any = {};

            props.data.iframeEndPoint.parameters.map((res: any) => {
                if (props.param[res]) {
                    params[`${res}`] = props.param[res]
                }
            });

            dispatch(fetchIframeData({
                url: props.data.iframeEndPoint.endpointUrl.replace("/api", ""),
                token: token.token,
                param: encodeFormData(params)
            }));

        } catch (e: any) {
            console.log("error", e);
        }
    }, [])

    useEffect(() => {
        if (iframeConfigData.isSuccess && iframeConfigData.data !== null) {

            eventer(messageEvent, function (a: any) {
                let b = a.data;

                if (b === "Submitted") {
                    onEmit("Submitted", iframeConfigData.data.url)
                } else {
                    switch (b.type) {
                        case "changeUrl":
                            window.location.href = b.value;
                            break;
                        case "complete":
                        case "updated": onEmit(b.type, iframeConfigData.data.url)
                            break;
                        default:
                            break;
                    }
                }
            }, !1);
            setIframeData(iframeConfigData.data);

            dispatch(resetfetchIframeData());
        } else if (iframeConfigData.isError) {
            setIframeData(null);

            dispatch(resetfetchIframeData());
        }
    }, [iframeConfigData])

    const onEmit = (event: any, url: any) => {
        props.emmitEvents(event, { event, url: url });
    }

    return (iframeData !== null ?
        <iframe
            id="iframeIns"
            ref={iframeRef}
            src={iframeData.url}
            style={{ width: "100%", height: "65vh" }}
            onLoad={() => {
                if (iframeRef.current) {
                    iframeRef.current?.contentWindow?.postMessage(iframeData.bearerToken, iframeData.url);
                }
            }}
        ></iframe> : <div className="loader"></div>)
};

export default IFrameWrapperDashboard;